import React, { FunctionComponent, useEffect, useState } from 'react';
import { Switch, Typography, Tooltip, Space } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import type { SwitchChangeEventHandler } from 'antd/es/switch';
import {
  defaultLumaOptions,
  LumaOptions as LumaOptionsType,
  NinjaModelsOptions,
} from '@monorepo/types';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface Props {
  updateOptions: (options: NinjaModelsOptions) => void;
}

const LumaOptions: FunctionComponent<Props> = ({ updateOptions }) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<LumaOptionsType>(defaultLumaOptions);

  const handleSwitchChange: SwitchChangeEventHandler = (checked) => {
    setOptions((prev) => {
      const newOptions = {
        ...prev,
        loop: checked,
      };

      updateOptions(newOptions);

      return newOptions;
    });
  };

  return (
    <Space style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Switch checked={options.loop} onChange={handleSwitchChange} />
      <Text>{t('assetsModal.aiVideo.loop')}</Text>
      <Tooltip
        placement={'right'}
        title={
          <span style={{ fontSize: '12px' }}>
            {t('assetsModal.aiVideo.loopTooltip')}
          </span>
        }
      >
        <InfoCircleOutlined style={{ cursor: 'pointer' }} />
      </Tooltip>
    </Space>
  );
};

export default LumaOptions;
